// extracted by mini-css-extract-plugin
export default {"font-renta":"ArsenalPagination_font-renta__0fefD","arsenalPagination":"ArsenalPagination_arsenalPagination__LZGyM","cursor":"ArsenalPagination_cursor__of8Mo"};